import {
  ComponentConfig,
  LayoutTypes,
  ComponentType,
  FlexDirection,
  ActionType,
} from "../services/types/ComponentTypes";

export const screen_143_payments: ComponentConfig[] = [
  {
    componentType: LayoutTypes.SCREEN_GROUP,
    fabAction: {
      type: "add",
      screenId: "144",
    },
    title: "Payments",
    style: {
      backgroundColor: "#F9FAFB", // bg-gray-50 from design system
    },
    childComponents: [
      {
        componentType: LayoutTypes.GROUP,
        style: {
          backgroundColor: "#ffffff",
          direction: FlexDirection.COLUMN,
          borderRadius: 12, // Design system: rounded-lg (12px)
          padding: 16, // Design system: p-4 (16px)
        },
        childComponents: [
          {
            componentType: ComponentType.SUMMARY_LIST,
            titleValue: "name",
            Name: "payment_summary",
            SummeryActions: [
              // {
              //   Action: {
              //     Action: "Navigate",
              //     Navigate: "modulev1/payment_add/<id>",
              //   },
              //   ActionType: "Edit",
              // },
              // {
              //   Action: {
              //     Action: "Delete",
              //     Module: "payment_summary",
              //   },
              //   ActionType: "Delete",
              // },

              {
                ActionType: ActionType.VIEW_REPORT,
                Action: {
                  Action: "Report",
                  Settings: "supplier_paid_amount_splitup",
                },
                tooltip: "View",
              },
              {
                ActionType: ActionType.VIEW_REPORT,
                Action: {
                  Action: "Report",
                  Settings: "supplier_statementof_accounts",
                },
                tooltip: "Statement of accounts",
              },
            ],
            Form: {
              Name: "payment_summary",
              TableName: "view_payments",
              DisplayName: "payment_summary",
              Fields: [
                {
                  IncludeLabel: true,
                  Label: "id",
                  BindValue: "id",
                  Json_Attribute: "id",
                  componentType: ComponentType.TEXT_FIELD,
                  showInSummary: false,
                },
                {
                  IncludeLabel: true,
                  Label: "Vendor name",
                  BindValue: "name",
                  Json_Attribute: "name",
                  componentType: ComponentType.TEXT_FIELD,
                  showInSummary: true,
                },
                {
                  IncludeLabel: true,
                  Label: "Vendor address",
                  BindValue: "address",
                  Json_Attribute: "address",
                  componentType: ComponentType.TEXT_FIELD,
                  showInSummary: true,
                },
                {
                  IncludeLabel: true,
                  Label: "Payable amount",
                  BindValue: "amount",
                  Json_Attribute: "amount",
                  componentType: ComponentType.TEXT_FIELD,
                  showInSummary: true,
                },
              ],
            },
          },
        ],
      },
    ],
  },
];

